import { Component, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { BrdsqlService } from '../../services/brdsql.service';


@Component({
  selector: 'app-edit-getfactor',
  templateUrl: './edit-getfactor.component.html',
  styleUrls: ['./edit-getfactor.component.css']
})
export class EditGetfactorComponent {
  userdata: any;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private brdsql: BrdsqlService) {
    this.userdata = this.auth.Authention();
    this.supzone = brdsql.sumZonne;
  }
  supzone = []

  ngOnInit(): void {

  }
  compNums(a, b) { return a - b; }

  yearN = { "yearTh": "6768", "yearlf": "67", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "state": 0 };
  edit_st = 0;
  selectS = [];
  todaydate = '';
  date2d: Date;
  dataApi0 = []; sum_Group = []; list_data_s = [];

  groupCode = '';
  Loaddata2() {
    this.todaydate = new Date().toLocaleString('th-TH', { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    //let date2 = this.date2d.toLocaleString('sv-SE', { year: "numeric", month: "2-digit", day: "2-digit" });
    this.spinner.show()
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=*&f=[dbo].[fnc_cutF6768]('${this.groupCode}')&w=1=1`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        //data = data.map(item => { return { ...item, select: false }; });
        this.dataApi0 = data;
        //console.log('Loaddata2:', data);
      }
      else { this.dataApi0 = []; }
    }).catch(err => { throw (err) })
  }

  dataApi1 = [];
  g_farmer = [];
  filter_data() {
    let aj = this.selectS;
    //let userD = this.userdata;
    this.g_farmer = [];
    if (this.dataApi0.length > 0) {
      this.dataApi1 = this.dataApi0.filter(el => aj.includes(el.groupCode));
      this.g_farmer = [...new Set(this.dataApi1.map(function (elem) { return (elem.fmname) }))].sort(this.compNums);
      //this.dataSource = this.dataApi1
      //console.log('list_sup:', this.dataApi1, '/zonedata ', userD.zonedata)
      console.log('g_farmer:', this.g_farmer)
    }
    else { this.dataApi1 = [] }
  }
  filter_data2() {
    let data = this.selectS;
    this.g_farmer = [];
    this.g_farmer = [...new Set(data.map(function (elem) { return (elem.fmname) }))].sort(this.compNums);
    console.log('selectS:', data)
  }

  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  printPage() {
    window.print();

  }

  calPercent(total: number, part: number): number {
    if (total == 0 || part == 0) {
      //console.error('Total value cannot be zero');
      return 0;
    }
    let num: number = parseFloat(((part / total) * 100).toFixed(2));
    return num;
  }

}
